import { Dropdown } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { locales, languageLabels, enLocale, LANGUAGE_STORAGE_KEY } from 'locales/i18n';
import { Button } from 'app/atoms';
import { saveToLocal, getFromLocal } from 'utils/cache';
import { useEffect } from 'react';

export const localeOptions = locales.map((locale) => ({
  key: locale,
  label: languageLabels[locale],
}));

const LanguagePicker = () => {
  const { i18n } = useTranslation();

  const currentLanguageLabel = languageLabels[i18n.language] || languageLabels['en'];

  useEffect(() => {
    const savedLanguage = getFromLocal(LANGUAGE_STORAGE_KEY, true);
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage as string);
    }
  }, []);

  const handleLanguageChange = (key: string) => {
    i18n.changeLanguage(key);
    saveToLocal(LANGUAGE_STORAGE_KEY, key || enLocale);
  };

  return (
    <Dropdown
      menu={{
        selectedKeys: [i18n.language],
        onClick: ({ key }) => handleLanguageChange(key),
        items: localeOptions,
      }}
    >
      <Button id="language-selector" className="p-2" icon={<GlobalOutlined className="text-lg" />}>
        <span className="!hidden lg:!inline-block ml-1">{currentLanguageLabel.slice(0, 2).toUpperCase()}</span>
      </Button>
    </Dropdown>
  );
};

export default LanguagePicker;
